import React, { useEffect, useState } from 'react';
import Table from 'components/Layout/Table';
import { limit } from 'utils/constants';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { objectToFormData, paymentColor } from 'utils/helpers';
import { fetchOtherConferencePasses } from 'store/slices';
import SeachInput from 'components/form/SeachInput';

const CommitteeMemberList = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { eventId } = params;
  const [abstractData, setAbstractData] = useState([]);
  const [searchPayload, setSearchPayload] = useState({
    email_id: '',
    member_id: '',
    phone_number: '',
  });

  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: limit,
    event_id: eventId,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [globalSearchVal, setGlobalSearchVal] = useState('');
  const [timer, setTimer] = useState('');

  const getOtherConferencePasses = async (obj) => {
    let forData = objectToFormData(obj);
    const response = await dispatch(fetchOtherConferencePasses(forData));
    setAbstractData(response?.data?.committee_members || []);
    setFilterData({
      ...obj,
      total: response?.data?.result_count || 0,
    });
    setIsLoading(false);
  };

  const handelChangeSearch = (searchData) => {
    setIsLoading(true);
    let newData = filterData;
    setSearchPayload(searchData);
    newData = { ...newData, ...searchData, offset: 0 };
    setFilterData(newData);
    getOtherConferencePasses(newData);
  };
  const handelChangePagination = (offset) => {
    setIsLoading(true);
    let newData = { ...filterData, ...searchPayload };
    newData = { ...newData, offset: offset };
    setFilterData(newData);
    getOtherConferencePasses(newData);
  };

  const handleGlobalSearch = (e) => {
    setGlobalSearchVal(e.target.value);
    let time = timer;
    clearTimeout(time);
    time = setTimeout(() => {
      let newData = { ...filterData, ...searchPayload };
      newData = { ...newData, global_filter: e.target.value, offset: 0 };
      setIsLoading(true);
      setFilterData(newData);
      getOtherConferencePasses(newData);
    }, 800);
    setTimer(time);
  };

  useEffect(() => {
    getOtherConferencePasses({ ...filterData, ...searchPayload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const header = [
    {
      isSearch: true,
      searchInputName: 'user_name',
      title: 'Name',
    },

    {
      isSearch: true,
      searchInputName: 'email_id',
      title: 'Email Id',
    },
    {
      isSearch: true,
      searchInputName: 'phone_number',
      title: 'Phone Number',
    },
    {
      isSearch: true,
      searchInputName: 'attendee_type',
      title: 'Attendee Type',
    },
    {
      isSearch: true,
      searchInputName: 'country',
      title: 'Country',
    },

    {
      isSearch: true,
      searchInputName: 'university',
      title: 'University',
    },

    {
      isSearch: true,
      searchInputName: 'attendance',
      title: 'Attendance',
    },
  ];


  const rowData = [];
  abstractData?.forEach((elem, index) => {
    const {
      attendance,
      attendee_type,
      country,
      email_id,
      phone_number,
      university,
      user_name,
      id,
    } = elem;
    let obj = [
      {
        value: user_name ? user_name : '-',
      },

      {
        value: email_id ? email_id : '-',
      },
      {
        value: phone_number ? phone_number : '-',
      },
      {
        value: attendee_type ? attendee_type : '-',
      },
      {
        value: country ? country : '-',
      },
      {
        value: university ? university : '-',
      },
      {
        value: (
          <div className={paymentColor(attendance)}>
            {attendance ? attendance : '-'}
          </div>
        ),
      },
    ];
    rowData.push({ data: obj });
  });

  return (
    <>
      <div className="d-flex justify-content-between align-items-center cpt-10 cpb-10">
        <div className="table-title">
          Committee Member Attendances ({filterData?.total})
        </div>

        <div className="d-flex align-items-center flex-wrap gap-3">
          <div className="d-flex">
            <SeachInput
              placeholder="Search here"
              id="global_filter"
              value={globalSearchVal}
              onChange={handleGlobalSearch}
            />
          </div>
        </div>
      </div>

      <Table
        isLoading={isLoading}
        header={header}
        rowData={rowData}
        filterData={filterData}
        // searchPayload={searchPayload}
        searchInputChange={handelChangeSearch}
        changeOffset={handelChangePagination}
      />
    </>
  );
};

export default CommitteeMemberList;
